module.exports = __webpack_public_path__ + "img/franchaise_ban.png";